@if (show) {
    <ngb-alert [type]="'danger'" class="" role="alert" (closed)="close()">
        <div class="container">
            @for (message of messages; track message) {
                <p>{{ message | translate }}</p>
            }
        </div>
    </ngb-alert>
}
